import React from 'react';
import styled from 'styled-components';
import colors from './constants/colors';
import mediaQueries from './constants/mediaQueries';

const OnboaderImage = styled.div`
  background-color: ${colors.ghostWhite};
  background-image: url('../assets/images/lars-full.jpg');
  background-position: top 1rem center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 65%;
  pointer-events: none;
  position: relative;
  width: 100%;

  ${mediaQueries.mobile`
    display: none;
  `}

  ${mediaQueries.desktop`
    padding-top: 0;
    height: 100%;
    background-size: 90%;
    background-position-y: 18rem;
  `}
`;

const OnboarderDetailsContainer = styled.div`
  background: ${colors.deepSapphire};
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  padding: 16px;
`;

const OnboarderDetails = styled.div`
  font-weight: 450;
  font-size: 16px;
  text-align: center;
  color: ${colors.white};
  padding: 1rem;
`;

export default function LarsImage() {
  return (
    <OnboaderImage>
      <OnboarderDetailsContainer>
        <OnboarderDetails>Lars · Onboarding Specialist</OnboarderDetails>
      </OnboarderDetailsContainer>
    </OnboaderImage>
  );
}
